const upperCase = function (editor) {

    editor.ui.registry.addToggleButton('upperCase', {
        icon: 'change-case',
        tooltip: 'Mayúsculas',
        onAction: function () {
            let value = editor.selection.getContent();
            editor.insertContent('<span style="text-transform: uppercase">' + value + '</span>');
        }
    });
}

export {upperCase};
